import React, { useEffect, useRef } from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCloudArrowUp, faLinkSlash } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"
import { useLocation } from "react-router-dom"
import { theme } from "../settings/config"
import { useSyncStatus } from "../services/sync.service"

// A bordo campo il segnale va e viene, e chi segna una presenza deve sapere
// se è arrivata o se aspetta la rete — senza doverlo indovinare dal fatto
// che "sembra salvata". La pastiglia in alto a destra lo dice, e sparisce
// quando non c'è niente da dire. Toccandola si legge cosa vuol dire.
//
// Sta dalla parte opposta di quella dell'ambiente (EnvironmentBadge), che
// nell'app pubblicata non c'è. Sulla pagina pubblica no: lì in quell'angolo
// c'è "Accedi", e chi non è entrato non ha niente da inviare.
const STATES = {
	offlinePending: {
		label: "Offline · da inviare",
		icon: faCloudArrowUp,
		bg: theme.colors.warning,
		explanation:
			"Sei senza rete. Quello che hai segnato è salvato sul telefono e parte da solo quando la rete torna",
	},
	offline: {
		label: "Offline",
		icon: faLinkSlash,
		bg: theme.colors.gunmetal_fill,
		explanation:
			"Sei senza rete. Lezioni, presenze e allievi si salvano sul telefono e partono quando torna; Google Calendar, le serie e il circolo aspettano la rete",
	},
	pending: {
		label: "Invio in corso",
		icon: faCloudArrowUp,
		bg: theme.colors.gunmetal_fill,
		explanation:
			"Ci sono modifiche che il server non ha ancora ricevuto: partono da sole, appena la connessione risponde",
	},
}

const stateOf = ({ online, pending }) => {
	if (!online) return pending ? STATES.offlinePending : STATES.offline
	if (pending) return STATES.pending
	return null
}

function ConnectionBadge() {
	const status = useSyncStatus()
	const location = useLocation()
	const current = location.pathname === "/" ? null : stateOf(status)

	// Quando quello che aspettava è arrivato lo si dice una volta: è la
	// risposta alla domanda che la pastiglia ha fatto venire.
	const shownSyncedAt = useRef(status.syncedAt)
	useEffect(() => {
		if (!status.syncedAt || status.syncedAt === shownSyncedAt.current) return
		shownSyncedAt.current = status.syncedAt
		toast.success("Modifiche inviate", {
			toastId: "sync-done",
			position: "top-center",
			autoClose: 3000,
		})
	}, [status.syncedAt])

	if (!current) return null

	const explain = () =>
		toast.info(current.explanation, {
			toastId: "connection-explanation",
			position: "top-center",
			autoClose: 8000,
		})

	return (
		<Div
			pos="fixed"
			top="calc(0.5rem + env(safe-area-inset-top))"
			right="0"
			zIndex="1000"
			bg={current.bg}
			p="0.15rem 0.5rem 0.15rem 0.6rem"
			rounded="l-20px"
			d="flex"
			align="center"
			cursor="pointer"
			role="status"
			aria-live="polite"
			onClick={explain}
			style={{ gap: "0.35rem", opacity: 0.95 }}>
			<FontAwesomeIcon icon={current.icon} color={theme.colors.white} size="xs" />
			<Text textSize="caption" textWeight="bold" textColor={theme.colors.white}>
				{current.label}
			</Text>
		</Div>
	)
}

export default ConnectionBadge
